import React from "react";

export type LimitType = "word" | "page" | "slide" | "time";

export interface Limit {
  type: LimitType;
  value: number;
  allowancePct: number; // plus/minus percentage allowed
}

interface Props {
  limit: Limit;
  onChange: (limit: Limit) => void;
  className?: string;
}

// Small compound input: select + two numbers
export default function LimitInput({ limit, onChange, className = "" }: Props) {
  const handleField = (key: keyof Limit, value: string) => {
    onChange({ ...limit, [key]: key === "type" ? (value as LimitType) : Number(value) });
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <select
        value={limit.type}
        onChange={(e) => handleField("type", e.target.value)}
        className="rounded-md border-gray-300 text-sm shadow-sm focus:border-primary focus:ring-primary"
      >
        <option value="word">Words</option>
        <option value="page">Pages</option>
        <option value="slide">Slides</option>
        <option value="time">Minutes</option>
      </select>
      <input
        type="number"
        value={limit.value}
        onChange={(e) => handleField("value", e.target.value)}
        min={0}
        placeholder="Value"
        className="w-24 rounded-md border-gray-300 text-sm shadow-sm focus:border-primary focus:ring-primary"
      />
      <span>±</span>
      <input
        type="number"
        value={limit.allowancePct}
        onChange={(e) => handleField("allowancePct", e.target.value)}
        min={0}
        placeholder="%"
        className="w-20 rounded-md border-gray-300 text-sm shadow-sm focus:border-primary focus:ring-primary"
      />
      <span className="text-sm text-gray-600">allowance</span>
    </div>
  );
}
